// Date 2023-02-23 14:43:08

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

            import sithMesCustomerEdit from "@/views/sithMes/customer/SithMesCustomerEdit.vue";
            import sithMesCustomerList from "@/views/sithMes/customer/SithMesCustomerList.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
            {
            path: "/sithMes/customer/sithMesCustomerEdit",
            name: "sithMesCustomerEdit",
            component: sithMesCustomerEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/sithMes/customer/sithMesCustomerList",
            name: "sithMesCustomerList",
            component: sithMesCustomerList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            }
]